<script setup lang="ts">
import type { Task } from '~/types/task.type'

const props = defineProps({
  task: {
    type: Object as PropType<Task<'withProject' | 'withTaskList'>>,
    required: true,
  },
})

const { draggedTask } = storeToRefs(useDragAndDropStore())

function setDraggedTask() {
  draggedTask.value = props.task
}
</script>

<template>
  <div
    class="group w-full flex justify-between items-center px-4 py-1 hover:bg-gray-300 dark:hover:bg-stone-800 draggable-task space-x-2"
    draggable
  >
    <div class="mr-2 flex flex-col text-2xl space-y-1">
      <div class="flex">
        <TimeTrackerButton :task-id="task.id" :button-props="{ text: true }" />
      </div>
      <div class="flex">
        <TimeEntryButton :task-id="task.id" :project-id="task.taskList.projectId" :button-props="{ text: true }" />
      </div>
    </div>
    <div class="text-left grow">
      <NuxtLink
        class="line-clamp-3 text-[12px] text-gray-600 font-bold dark:text-gray-500 hover:underline"
        :to="{ name: 'tasks-id', params: { id: task.id } }"
      >
        {{ task.name }}
      </NuxtLink>
      <NuxtLink
        class="line-clamp-2 text-[12px] hover:underline"
        :to="{ name: 'projects-id-view', params: { id: task.taskList.project!.id, view: 'tasks' } }"
      >
        {{ task.taskList.project!.name }}
      </NuxtLink>
    </div>
    <NTooltip>
      <template #trigger>
        <div @mousedown="() => setDraggedTask()">
          <UIcon name="i-ic-baseline-drag-indicator" class="text-neutral shrink-0 cursor-grab" />
        </div>
      </template>
      Klicken und Aufgabe in die Zeiterfassung ziehen
    </NTooltip>
  </div>
</template>
